import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="dev-ls38i3q4ulf06qf7.us.auth0.com"
      clientId="9w67W1voqqE26m8BmUzcHN9adCHW7fIe"
      redirectUri="https://www.jandjind.com/06fa905d7f2aaced6dc72e9511c71a2a51e8aead"
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);